// extracted by mini-css-extract-plugin
module.exports = {"radioButtonStyles":"styles_radioButtonStyles__3Xh0G","blackButton":"styles_blackButton__2KlW9","ant-btn-primary":"styles_ant-btn-primary__13NrG"};